import * as React from "react";
import styled from "styled-components";

import { ActionBox, DefaultIcon, InfoBox } from "../styled";
import PbxRow from "../PbxRow";
import InfoRow from "../InfoRow";
import TenantRow from "../TenantRow";
import ClearAction from "./ClearAction";
import extractBaseCustomerInfo from "@/react/components/customer/modal/extractBaseCustomerInfo";

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 16px;
`;

const CurrentCustomerInfo = ({
  customerData,
  onClearCustomer,
  pbxOptions,
  selectedPbx,
  onPbxUpdated,
  selectedTenant,
  tenantOptions,
  onTenantUpdated,
  menuPortalTarget,
}) => {
  const baseInfo = React.useMemo(
    () => extractBaseCustomerInfo(customerData),
    [customerData]
  );

  return (
    <Container>
      <InfoBox>
        {baseInfo.map((item) => (
          <InfoRow
            renderIcon={() => <DefaultIcon />}
            attributeName={item.displayName}
            value={item.value}
            key={item.key}
          />
        ))}
        <PbxRow
          pbxOptions={pbxOptions}
          selectedPbx={selectedPbx}
          setSelectedPbx={onPbxUpdated}
          menuPortalTarget={menuPortalTarget}
          selectorTestId="current-customer-info-pbx-select"
        />
        <TenantRow
          tenantOptions={tenantOptions}
          selectedTenant={selectedTenant}
          setSelectedTenant={onTenantUpdated}
          menuPortalTarget={menuPortalTarget}
          selectorTestId="current-customer-info-tenant-select"
        />
      </InfoBox>
      <ActionBox>
        <ClearAction onClick={onClearCustomer} />
      </ActionBox>
    </Container>
  );
};

export default CurrentCustomerInfo;
